import { makeInlineText } from './internal/makeInlineText';
/**
 * Это компонет типогрфики, т.е. оформления текста. <br>Для оформления текста в библиотеке используются компоненты:<br>
 * `InlineText1-4`, `Paragraph1-4`, `Header1-7`.<br>Пример подключения: `import { Header1 } from '@cian/ui-kit/typography';` <br>
 * Номер в названии компонента означает размер текста(чем больше цифра - тем меньше размер).
 * Кроме того для импорта доступны классы (`@cian/ui-kit/typography/sizes.css`) и перменные (`@cian/ui-kit/typography/variables.css`) базовой типогрфики.
 * */

export var InlineText1 = makeInlineText({
  fontSize: '16px',
  lineHeight: '22px'
});
/**
 * Это компонет типогрфики, т.е. оформления текста. <br>Для оформления текста в библиотеке используются компоненты:<br>
 * `InlineText1-4`, `Paragraph1-4`, `Header1-7`.<br>Пример подключения: `import { Header1 } from '@cian/ui-kit/typography';` <br>
 * Номер в названии компонента означает размер текста(чем больше цифра - тем меньше размер).
 * Кроме того для импорта доступны классы (`@cian/ui-kit/typography/sizes.css`) и перменные (`@cian/ui-kit/typography/variables.css`) базовой типогрфики.
 * */

export var InlineText2 = makeInlineText({
  fontSize: '14px',
  lineHeight: '20px'
});
/**
 * Это компонет типогрфики, т.е. оформления текста. <br>Для оформления текста в библиотеке используются компоненты:<br>
 * `InlineText1-4`, `Paragraph1-4`, `Header1-7`.<br>Пример подключения: `import { Header1 } from '@cian/ui-kit/typography';` <br>
 * Номер в названии компонента означает размер текста(чем больше цифра - тем меньше размер).
 * Кроме того для импорта доступны классы (`@cian/ui-kit/typography/sizes.css`) и перменные (`@cian/ui-kit/typography/variables.css`) базовой типогрфики.
 * */

export var InlineText3 = makeInlineText({
  fontSize: '12px',
  lineHeight: '18px'
});
/**
 * Это компонет типогрфики, т.е. оформления текста. <br>Для оформления текста в библиотеке используются компоненты:<br>
 * `InlineText1-4`, `Paragraph1-4`, `Header1-7`.<br>Пример подключения: `import { Header1 } from '@cian/ui-kit/typography';` <br>
 * Номер в названии компонента означает размер текста(чем больше цифра - тем меньше размер).
 * Кроме того для импорта доступны классы (`@cian/ui-kit/typography/sizes.css`) и перменные (`@cian/ui-kit/typography/variables.css`) базовой типогрфики.
 * */

export var InlineText4 = makeInlineText({
  fontSize: '10px',
  lineHeight: '16px'
});